import React, { useState, useRef, useEffect } from "react";
import AttendanceItem from "./AttendanceItem";
import "./attendance_record.css";

const AttendanceRecord = ({ records, getMonthsFilter, getDaysData, setAttendanceType, setActionModal, setAttendanceDate }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [filterInputList, setFilterInputList] = useState([{}]);
  const [open, setOpen] = useState(false);

  const currentMonth = new Date().getMonth() + 1;
  const currentYear = new Date().getFullYear();

  // const handleFilter = async (key, value) => {  
  //   const [month, year] = value.split("-");
  
  //   const list = [...filterInputList];
  //   list[0][key] = month; 
  //   list[0]['year'] = year; 
    
  //   setFilterInputList(list);
  // };
  
  // const handleSubmitFilter = async () => {
  //   const listStatus = [0];
  //   localStorage.setItem(
  //     "regularization_filters",
  //     JSON.stringify(filterInputList)
  //   );
  //   setOpen(false);
  //   setIsLoading(true);
  //   await getDaysData(filterInputList[0]?.months, filterInputList[0]?.year);
  //   setIsLoading(false);
  // };
  

  // const handleRemoveFilter = async (key) => {
  //   const listStatus = [0];
  //   if (key !== "") {
  //     if (filterInputList === undefined || filterInputList === null) {
  //       delete window.localStorage.regularization_filters;
  //     }
  //     delete filterInputList[0][key];
  //     setFilterInputList(filterInputList);
  //     setIsLoading(true);
  //     await getDaysData(currentMonth, currentYear);
  //     setIsLoading(false);
  //   }
  // };

  const monthNumber = filterInputList[0]?.months || currentMonth;
  const year = currentYear;
  let monthName = "";

  if (monthNumber) {
    const date = new Date(year, monthNumber - 1);
    monthName = date.toLocaleString("default", { month: "long" });
  }

  const monthNames = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];
  

  return (
    <div className="attendance-record">
      {Array.isArray(records) &&
        records.map((record, index) => (
          <AttendanceItem
            key={index}
            record={record}
            getDaysData={getDaysData}
            setAttendanceType={setAttendanceType}
            setActionModal={setActionModal}
            setAttendanceDate={setAttendanceDate}
            // setSelectedUser={setSelectedUser}
          />
        ))}
    </div>
  );
};

export default AttendanceRecord;
